(function() {
  'use strict';

  angular.module('ringbaPortal').component('cappedValueDisplay', {
    bindings: {
      value: '<',
      cap: '<',
      isAmountType: '<',
    },
    controller: CappedValueDisplayController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/capped-value-display/capped-value-display.view.html'
  });

  function CappedValueDisplayController() {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
    }
  }
})();
